export default "__VITE_ASSET__BfJqDV$i__"